import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SearchResultList } from './search-result-list';
import { ShipmentListItem } from './shipment-list-item';
import { messages } from '../messages';

/**
 * @typedef {import('./types').OrderSearchResult} OrderSearchResult
 * @typedef {import('./types').FulfillmentPlanSearchResult} FulfillmentPlanSearchResult
 */

/**
 * @param {FulfillmentPlanSearchResult} fulfillmentPlan
 * @param {string|number} displayIndex
 * @returns {JSX.Element}
 */
const renderFulfillmentPlan = (fulfillmentPlan, displayIndex) => {
  const { orderGridStatus, items } = fulfillmentPlan;
  return <ShipmentListItem displayIndex={displayIndex} items={items} orderGridStatus={orderGridStatus} />;
};

/**
 * @param {object} props
 * @param {OrderSearchResult[]} props.fulfillmentPlans - The fulfillment plans to display.
 * @param {string} props.searchText - The text to search for.
 * @param {() => void} props.onClose - Function to call when the close button is clicked.
 * @param {(fulfillment: OrderSearchResult, displayIndex?: string|number) => void} props.onFulfillmentPlanClicked - Function to call when a fulfillment plan is clicked.
 * @returns {JSX.Element}
 */
export const ShipmentList = ({ fulfillmentPlans, searchText, onClose, onFulfillmentPlanClicked }) => (
  <SearchResultList
    bodyText={<FormattedMessage {...messages.salesOrderListMultipleMatchesShipment} values={{ searchText }} />}
    header={<FormattedMessage {...messages.salesOrderListMatches} values={{ searchText }} />}
    items={fulfillmentPlans}
    keyField='fulfillmentPlanId'
    onClose={onClose}
    onItemClick={onFulfillmentPlanClicked}
    renderItem={renderFulfillmentPlan}
  />
);
